import React from 'react';

const QualityBreakdown = ({ categories, isSkeletonLoader, skeletonStyles }) => {
  return (
    <div className="space-y-4">
      {categories.map((category) => (
        <div key={category.label} className="space-y-2">
          <div className="flex justify-between text-sm">
            <span className="text-gray-600">{category.label}</span>
            <div className="flex items-center md:gap-1 gap-2">
              <span className={`text-gray-500 whitespace-nowrap ${isSkeletonLoader && skeletonStyles}`}>({category.amount} / {category.total})</span>
              <span className={`font-medium ${isSkeletonLoader && skeletonStyles}`}>{category.percentage}%</span>
            </div>
          </div>
          <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
            <div
              className={`h-full transition-all duration-500 ${category.color}`}
              style={{ width: `${category.percentage}%` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default QualityBreakdown; 